import { mapGetters } from "vuex";
import Toast from "../Toast/index";
import Overlay from "../Overlay";
import ActionButton from "../ActionButton";
import ConfirmationModal from "../ConfirmationModal";

// import $ from 'jquery'
export default {
  name: "EplNewQuickLinks",
  components: {
    Toast,
    Overlay,
    ActionButton,
    ConfirmationModal
  },
  props: ["device", "title"],
  data() {
    return {
      message: {}
    };
  },
  computed: {
    ...mapGetters(["quickLinksNewDashboard", "userType", "user"])
  },
  mounted() {
    this.$store.commit("setServiceType", undefined);
    this.$store.dispatch("quickLinksNewDashboard");
  },
  methods: {
    emitEvent(link) {
      this.$store.commit("setServiceType", link.type);
      link.skipTxnCheck ? false : this.$emit("on-click", link.clickUrlPath);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/EplNewQuickLinks/component.js